// @givmo/board — every word CBG-UX9 adds: after "Add a member", the same dialog asks whether to invite
// the new member (design stop design-282's frames s1–s4, c1 and p1).
//
// ══ WHICH WORDS ARE APPROVED ════════════════════════════════════════════════════════════════════
//
// All of them, as built. The lines marked APPROVED are shipped lines reused word for word (the member
// page's, the add form's, the seat dialog's); Jonathan approved every other line with the step's
// frames (D-CBG-38, in-chat 2026-10-24 12:10 PDT; `scratchpad/2026-10-24-invite-step-design/
// review.html`), Invite the primary button. The two lines changed since, after the user test, were
// approved in CBG-UX-COPY2 (D-CBG-42, 2026-10-24 19:08 PDT): one rewritten (B1), one kept (B2).
// Everything after Invite is the shipped invitation's
// (`invitation-dialog.tsx`), one copy for both ways in. Each line names the frame that draws it.
//
// ⚠ Plan §3.2 binds every line: what Board sends and records, never that the organization should
// invite anyone now. "Not now" is an answer as good as "Invite" (D-CBG-32 (d) keeps a board's
// directors uninvited until it is ready), so no line presses for the invitation.

export const inviteStepWords = {
  /** Drawn s1, c1 and p1: the invitation's own title, as a question. */
  title: (invitationTitle: string) => `${invitationTitle}?`,
  /** APPROVED (the member page's "Joining the board" card, word for word; drawn s1, c1 and p1): what
   *  an invitation is for, and that the board's work goes on without one. */
  lead: 'They join from your invitation with their own Givmo account. Until then you can record their signatures and replies for them.',
  /** APPROVED (the add form's label). */
  emailLabel: 'Email of record',
  /** Drawn s2: under the field while it holds an address that differs from the seat's. Not now keeps
   *  an edited address too, so the line says either answer changes it. Approved in CBG-UX-COPY2
   *  (B1), in place of the drafted "Either way, …" after the user test. */
  addressChanges: (name: string) =>
    `This becomes ${name}’s email of record, whether you invite them now or not.`,
  /** Drawn s1 and p1: where the invitation is once this dialog is gone, said before the choice. */
  later: 'Not now? Invite them later from the ⋯ menu on their row.',
  /** Drawn c1: a seat for someone who isn't on the board. The committee page behind shows their row
   *  with a pencil and no ⋯, and their name there opens their page, where "Looking after this seat"
   *  offers the invitation (`member-detail-page.tsx`). Approved as drafted in CBG-UX-COPY2 (B2); it
   *  replaced the approved "…from the ⋯ menu on their row in Board members." Its last two words are
   *  kept on one line (a no-break space), so at the dialog's width the line never ends on
   *  "Members." alone. */
  laterFromTheirPage:
    'Not now? Invite them later from their page: select their name under\u00a0Members.',
  /** Drawn s1. */
  notNow: 'Not now',
  /** Drawn s1 (Jonathan's word). */
  invite: 'Invite',
  /** APPROVED, reused (the seat dialog's): an address change refused with no sentence of the
   *  backend's. */
  saveFailed: 'We couldn’t save that. Please try again.',
} as const;
